module.exports = __webpack_public_path__ + "img/3.7.Chla.a5d75b12.png";